/** Applicant statuses at or after the documents-requested workflow step. */
export const APPLICANT_DOCUMENTS_VISIBLE_STATUS_CODES = [
  'DOCUMENTS_PENDING',
  'DOCUMENTS_COMPLETED',
  'SHORTLISTING_SENT',
  'CONDITIONAL_OFFER_RECEIVED',
  'UNCONDITIONAL_OFFER_RECEIVED',
] as const;

export function isApplicantDocumentsSectionVisible(statusCode?: string): boolean {
  if (!statusCode?.trim()) return false;
  return (APPLICANT_DOCUMENTS_VISIBLE_STATUS_CODES as readonly string[]).includes(statusCode);
}
